import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import '../App.css';
import CancelModalComponent from '../popUpModals/CancelModalComponent';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class UserRoles extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            reDirect: '',
            email: '',
            userRole: ''
        }
    }
    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
            }, () => {
            })
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }

    changeValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onCancelChanges() {
        this.setState({
            reDirect: './userSummary'
        })
    }

    toContinue(event) {
        event.preventDefault();
        if (this.props.values.rolename === 'Attorney') {
            if (this.props.values.supervisor === "") {
                this.setState({
                    ...this.state,
                    errorMessage: "Please select supervisor"
                })
            } else {
                this.setState({
                    ...this.state,
                    errorMessage: " "
                }, () => {
                    this.props.nextStep();
                })
            }

        } else {
            this.props.nextStep();
        }

    }

    toBack(event) {
        event.preventDefault();
        if (this.props.values.update) {
            this.props.stepFour();
        } else {
            this.props.prevStep();
        }
    }

    showModal = (event) => {
        event.preventDefault();
        this.setState({
            ...this.state,
            show: true
        })
    }

    onCloseModal() {
        this.setState({
            show: false
        })
    }

    onSupervisorChange(event) {
        this.props.onSupervisorChange(event.target.value);
        if (event.target.value === "") {
            this.setState({
                ...this.state,
                errorMessage: "Please select supervisor"
            })
        } else {
            this.setState({
                ...this.state,
                errorMessage: " "
            })
        }
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect
                }} />
        }
        const { values, onRolesChange } = this.props;
        return (
            <React.Fragment>
                <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                    <div className="container mt-2 ">
                        <h4>Select User Role </h4>
                        <hr></hr>
                        <div className="Row">
                            <input type="radio" className="form-check-input" name="adminsRadios"
                                id="amoptionId" value="ADMIN"
                                checked={values.rolename === 'Admin' ? true : false}
                                onChange={onRolesChange('Admin')} /> <label
                                    className="form-check-label" for="amoptionId">Admin </label>
                        </div>
                        <div className="Row">
                            <input type="radio" className="form-check-input" name="supervisor"
                                id="supervisorId" value="Supervisor"
                                checked={values.rolename === 'Supervisor' ? true : false}
                                onChange={onRolesChange('Supervisor')}
                            /> <label
                                className="form-check-label" for="supervisorId">Supervisor </label>
                        </div>
                        <div className="Row">
                            <input type="radio" className="form-check-input" name="attorney"
                                id="attorneyId" value="Attorney" checked={values.rolename === 'Attorney' ? true : false}
                                onChange={onRolesChange('Attorney')}
                            /> <label
                                className="form-check-label" for="attorneyId">Attorney </label>
                        </div>

                        {values.rolename === 'Attorney' && <div className="form-group mt-2"  >
                            <div className="row">
                                <label className="col-5 " style={{ width: '15%', textAlign: 'right' }}> <b>Select Supervisor</b><span className="required"></span>
                                    <b className="float-left " style={{ width: '5%' }}>:</b>
                                </label>
                                <div style={{ width: '20%' }}>
                                    <select className=" col-12" name="supervisor" value={values.supervisor} onChange={(event) => this.onSupervisorChange(event)}  >
                                        <option value="">Select</option>
                                        {values.supervisorsList.map((supervisor) => (
                                            <option key={supervisor.supervisorId} value={supervisor.supervisor}
                                            >{supervisor.supervisor}</option>
                                        ))}
                                    </select>
                                    <p className="text-danger" style={{ width: '250px' }}>{this.state.errorMessage} </p> </div>
                            </div>
                        </div>}

                        <hr></hr>
                        <main>
                            <div className="row mb-2 mt-2">
                                <div className="col-md-6 mr-auto text-left">
                                    <button className="btn  btn-primary" onClick={(event) => this.toBack(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</button>
                                    <button className="btn  btn-primary" onClick={(event) => this.toContinue(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Continue</button>
                                    <button className="btn  btn-primary" onClick={this.showModal} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel  </button>
                                </div>
                            </div>
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                        </main>
                    </div >
                </section >
            </React.Fragment>
        )
    }
}
export default connect(mapStateToProps)(UserRoles);